import { render, staticRenderFns } from "./MainPagePrint.vue?vue&type=template&id=85362808"
import script from "./MainPagePrint.vue?vue&type=script&lang=js"
export * from "./MainPagePrint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports